import DynamicLoader from '../customComponents/DynamicLoader';
import DynamicReloader from '../customComponents/DynamicReloader';
import DynamicErrorDisplay from '../customComponents/DynamicErrorDisplay';
import DynamicRichContent from '../customComponents/DynamicRichContent';
import Rate from '../customComponents/Rate';
import Intro from '../customComponents/Intro';
import End from '../customComponents/End';
import I18nMessage from '../customComponents/I18nMessage';
import I18nOptions from '../customComponents/I18nOptions';
import I18nService from '../../services/I18nService';
import ConfigService from '../../services/ConfigService';

/**
 * Validate user input, to prevent transmission of very long text to API
 * * max length
 * @param {string} v
 * @return true if ok, message callback if ko
 */
const userValidator = (v) => {
  const myConfigService = ConfigService.getInstance();
  const myI18nService = I18nService.getInstance();

  if (!myConfigService.initialized || myConfigService.input_maxlength === undefined)
    return true;

  if (v.length <= myConfigService.input_maxlength)
    return true;

  return myI18nService.tr('label.validating.error.maxlength',myConfigService.input_maxlength);
};


const DEFAULT_STEPS = [
  {
    id: 'intro',
    component: (
      <Intro />
    ),
    delay: 0,
    trigger: 'user',
  },
  {
    id: 'user',
    user: true,
    trigger: '3',
    validator: userValidator
  },
  {
    id: '3',
    component: (
      <DynamicLoader />
    ),
    delay: 0,
    waitAction: true, // le trigger doit etre lancé programmatiquement
    // replace: true,  // le composant sera remplacé par l'étape suivante !! on perd les value
  },
  {
    id: 'check_answer',
    component: (
      <DynamicReloader />
    ),
    delay: 0,
    waitAction: true, // le trigger doit etre lancé programmatiquement
    // replace: true,  // le composant sera remplacé par l'étape suivante !! on perd les value
  },
  {
    id: 'label',
    delay: 0,
    message: ({ previousValue, steps }) => {return previousValue},
    trigger: ({ value, steps }) => 'user',
  },
  {
    id: 'error',
    delay: 0,
    component: (
      <DynamicErrorDisplay />
    ),
    trigger: 'user'
  },
  {
    id: 'rich',
    delay: 0,
    component: (
      <DynamicRichContent />
    ),
    waitAction: true, // le trigger doit etre lancé programmatiquement
  },
  {
    id: 'continueLabel',
    delay: 0,
    component: (
      <I18nMessage labelKey="label.continue.message" />
    ),
    trigger: 'continueOptions',
  },
  {
    id: 'continueOptions',
    delay: 0,
    component: (
      <I18nOptions options={[{value: 'true', labelKey: 'label.continue.yes', trigger: 'user'},{value: 'false', labelKey: 'label.continue.no', trigger: 'rateLabel'}]} />
    ),
    waitAction: true, // le trigger doit etre lancé programmatiquement
  },
  {
    id: 'rateLabel',
    delay: 0,
    component: (
      <I18nMessage labelKey="label.rating.message" />
    ),
    trigger: 'rateOptions',
  },
  {
    id: 'rateOptions',
    delay: 0,
    component: (
      <Rate />
    ),
    waitAction: true, // le trigger doit etre lancé programmatiquement
    trigger: 'end'
  },
  {
    id: 'end',
    delay: 0,
    component: (
      <End />
    ),
    waitAction: true, // le trigger doit etre lancé programmatiquement
  },
  {
    id: 'plugin_end',
    delay: 0,
    component: (
      <></>
    ),
    end: true,
  },
];
export {DEFAULT_STEPS};